/** Regiões geográficas do Brasil (IBGE). Enum inteiro para representação tipada no front. */
export enum RegiaoGeograficaEnum {
    Norte = 1,
    Nordeste = 2,
    CentroOeste = 3,
    Sudeste = 4,
    Sul = 5,
}
